/**
 * Copyright 2023, IntraLinks, Inc. All rights reserved.
 */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { AppThunk } from '../../app/store';
import Repos from '../../infrastructure/repositories/Repos';
import { IConsentScopesProperties } from '../../domain/models/IConsentScopes';

export interface IConsentState {
  scopes: IConsentScopesProperties[];
}

const initialState: IConsentState = {
  scopes: []
};

export const consentSlice = createSlice({
  name: 'consent',
  initialState,
  reducers: {
    getConsentScopes: (state: IConsentState, action: PayloadAction<{ items: IConsentScopesProperties[] }>): void => {
      state.scopes = action.payload.items;
    }
  }
});

export const {
  getConsentScopes
} = consentSlice.actions;

export const consentAccepted = (action: string, scopes: string[]): AppThunk => async (): Promise<void> => {
  await Repos.instance.consentRepository.createWithRedirect({ action, scopes }, undefined);
};

export const consentDeclined = (action: string): AppThunk => async (): Promise<void> => {
  await Repos.instance.consentRepository.createWithRedirect({ action }, undefined);
};

export const consentScopes = (): AppThunk => async (dispatch): Promise<void> => {
  try {
    const scopes = await Repos.instance.consentScopesRepository.getAll(undefined, undefined);
    dispatch(getConsentScopes({ items: scopes.items }));
  } catch (error) {
    const err = error as AxiosError;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { _status: statusInfo } = err?.response?.data || {};

    const errorStatusCode = statusInfo
      ? statusInfo?.status : undefined;
    throw errorStatusCode || '500';
  }
};

export default consentSlice.reducer;
